<template>
  <div class="cp-set-categories main">
    <div class="divider" />

    <div class="row">
      <p>
        <i class="fa fa-cat icon" />Categories
        <span class="is-pulled-right tag is-rounded"
          >{{ visibleCatCount }} categories</span
        >
      </p>

      <div style="margin-top: 10px">
        <textarea
          class="textarea"
          v-model="categories"
          placeholder="Pizza, Italian, Pasta, Organic"
          rows="3"
        />
      </div>
      <div
        style="margin-top: 6px; margin-left: 4px; color: grey; font-size: 0.9em"
      >
        <p>
          Comma-separated list of categories relevant to your shop. Put the most
          important categories first:
        </p>
        <p><i>Pizza, Italian, Pasta</i></p>
      </div>
      <div class="save-wrapper">
        <p v-if="updatingCategories" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveCategories">
          Save
        </p>
      </div>
    </div>

    <div class="divider" />

    <div class="row" style="background-color: #eef">
      <p>
        <i class="fa fa-magic icon" />
        Special Categories
        <span style="float: right; font-size: 0.8em; font-weight: 500"
          >Superuser Only</span
        >
      </p>

      <div style="margin-top: 10px">
        <textarea
          class="textarea"
          v-model="special"
          placeholder="_NEW*, _10PercentOff"
          rows="3"
        />
      </div>
      <div
        style="margin-top: 6px; margin-left: 4px; color: grey; font-size: 0.9em"
      >
        <p>Hidden tags start with underscore: <i>_promo</i></p>
        <p>Special tags start with "_" and end with "*": <i>_NEW*</i></p>
      </div>
      <div class="save-wrapper">
        <p v-if="updatingCategories" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveCategories">
          Save
        </p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "CPSetCategories",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      categories: null, // visibleCategories
      special: null, // hiddenCategories
      updatingCategories: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    visibleCatCount() {
      if (!this.business.data.categories) return 0;
      var catsStr = this.business.data.categories;
      var arr = catsStr
        .split(",")
        .map((s) => {
          s = s.trim();
          if (!s.startsWith("_")) return s.replace(/\*/g, "");
        })
        .filter((s) => s);
      return arr.length;
    },
    visibleCategories() {
      if (!this.business.data.categories) return null;
      var catsStr = this.business.data.categories;
      var arr = catsStr
        .split(",")
        .map((s) => {
          s = s.trim();
          if (!s.startsWith("_")) return s.replace(/\*/g, "");
        })
        .filter((s) => s);
      return arr.join(", ");
    },
    hiddenCategories() {
      if (!this.business.data.categories) return null;
      var catsStr = this.business.data.categories;
      var arr = catsStr
        .split(",")
        .map((s) => {
          s = s.trim();
          if (s.startsWith("_")) return s;
        })
        .filter((s) => s);
      return arr.join(", ");
    },
  },
  mounted() {
    this.categories = this.visibleCategories;
    this.special = this.hiddenCategories;
  },
  methods: {
    saveCategories() {
      if (!this.categories || this.categories.length < 5) {
        var msg = "Enter valid categories";
        this.errorToast(msg);
        return;
      }
      this.updatingCategories = true;
      var obj = { categories: `${this.categories} , ${this.special}` };
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated categories");
          this.business.data = res.data.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingCategories = false));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
</style>
